var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showQR && _vm.generateString)?_c('qrcode-vue',{attrs:{"value":_vm.generateString,"size":_vm.size,"level":"L","background":"#ffffff","foreground":"#000000"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }